// 基础设置 form
export const formSchemas = [
  {
    field: 'userName',
    defaultValue: '',
    component: 'Input',
    label: '账号',
    placeholder: '请输入账号',
    rules: [
      {
        required: true,
        message: '账号不能为空'
      }
    ]
  },
  {
    field: 'mobile',
    defaultValue: '',
    component: 'Input',
    label: '手机号',
    placeholder: '请输入手机号',
    rules: []
  },
  {
    field: 'password',
    defaultValue: '',
    component: 'Input',
    label: '密码',
    placeholder: '请输入密码',
    rules: []
  },
  {
    field: 'tenantId',
    defaultValue: '',
    component: 'Input',
    label: '租户id',
    disabled: true,
    placeholder: '',
    rules: [
      {
        required: true,
        message: '租户不能为空'
      }
    ]
  }
  // {
  //   field: 'userRoleList',
  //   defaultValue: [],
  //   component: 'Checkbox',
  //   label: '用户角色',
  //   placeholder: '请选择用户角色',
  //   checkboxArr: [],
  //   rules: [
  //     {
  //       required: true,
  //       message: '用户角色不能为空'
  //     },
  //     {
  //       validator: (rule, value, callback) => {
  //         if (!value.length) {
  //           callback(new Error('用户角色不能为空'))
  //         } else {
  //           callback()
  //         }
  //       }
  //     }
  //   ]
  // }
]

export const formRule = {
  userName: [
    { required: true, message: '账号未填写', trigger: 'blur' },
    { pattern: /^[0-9a-zA-Z_]{1,16}$/, message: '账号格式不正确' }
  ],
  mobile: [{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确' }],
  password: [
    { required: true, message: '密码未填写', trigger: 'blur' },
    { min: 6, max: 18, message: '密码长度为6到18位' }
  ]
}
